import styled from 'styled-components';
import { getColorShade, getColor, getSizeBy } from '../../../../../../src/styled/utils';
import { groupRadius } from '../../../../../styled/utils';
import { Body2Styles } from '../../../../typography';
import { TextInput } from '../../../../text-input';
export const Wrapper = styled.form `
  flex-grow: 1;
  padding-left: ${getSizeBy(4)};
`;
export const SearchInput = styled(TextInput) `
  margin-bottom: 0;
  border: none;

  & > div {
    background-color: inherit;
    border: 1px solid ${getColorShade('onSurface', 'outline')};
    border-radius: ${groupRadius()};

    &:focus-within,
    &:hover {
      border: 1px solid ${getColor('primary')};
    }

    & > input {
      color: ${getColorShade('onSurface', 'mediumEmphasis')};
      font-weight: normal;
      background-color: inherit;
      ${Body2Styles}
    }

    & path {
      fill: ${getColorShade('onSurface', 'mediumEmphasis')};
    }
  }
`;
